import { createContext } from 'react';
import PermissionsContextModel from './PermissionsContextModel';
const PermissionsContext = createContext(PermissionsContextModel);
export default PermissionsContext;